<template>
  <v-container
    fluid
    class="master-container pt-0"
    :class="{ 'om-design': whitelabel.omDesign }"
  >
    <v-container class="component-container">
      <div class="calculator-container">
        <v-col
          xl="6"
          lg="6"
          md="12"
          sm="12"
          xs="12"
          :class="mobileClass"
          class="calculator-column make-full-width this-one"
        >
          <v-col cols="12" class="make-full-width">
            <v-row class="summary-of-assets-container flex-column">
              <h3 class="header-title">Summary of your assets</h3>
              <v-col xl="10" lg="12" class="pa-0">
                <p class="summary-info">
                  The below is the total value of each of your assets. The more
                  accurate these asset values are, the more accurate your cost
                  estimate will be for winding up your estates.
                </p>
              </v-col>
              <v-card class="w-100 card-container">
                <v-card-text class="calculator-card">
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="properties"
                        name="properties"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyPropertiesValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('properties')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('properties')"
                          @blur="handleBlur('propertiesValue')"
                          :name="'properties'"
                          :hint="getHint('properties')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="life-policies"
                        name="life-policies"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyLifePoliciesValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('life-policies')"
                          @focus="handleFocus('life-policies')"
                          @blur="handleBlur('lifePoliciesValue')"
                          :name="'life-policies'"
                          :hint="getHint('life-policies')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="vehicles"
                        name="vehicles"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyVehiclesValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('vehicles')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('vehicles')"
                          @blur="handleBlur('vehiclesValue')"
                          :name="'vehicles'"
                          :hint="getHint('vehicles')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="other-assets"
                        name="other-assets"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyOtherAssetsValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('other-assets')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('other-assets')"
                          @blur="handleBlur('otherAssetsValue')"
                          :name="'other-assets'"
                          :hint="getHint('other-assets')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row
                    class="align-center info-row"
                    v-if="!whitelabel.omDesign"
                  >
                    <v-col class="d-flex align-center info-column">
                      <v-label class="calculator-label"
                        >Do you have any liabilities? (mortgages, finance,
                        debt…)</v-label
                      >
                    </v-col>
                  </v-row>
                  <v-row class="align-center calculator-row">
                    <v-col class="d-flex align-center calculator-value-column">
                      <ValidationProvider
                        id="total-liabilities"
                        name="total-liabilities"
                        class="w-100"
                      >
                        <TextField
                          v-model="currencyTotalLiabilitiesValue"
                          pattern="[0-9\s]*"
                          prefix="R"
                          :label="getTitle('total-liabilities')"
                          @keypress="isNumber($event)"
                          @focus="handleFocus('total-liabilities')"
                          @blur="handleBlur('totalLiabilitiesValue')"
                          :name="'total-liabilities'"
                          :hint="getHint('total-liabilities')"
                        />
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row
                    class="align-center justify-center center-row button-row"
                  >
                    <GradientButton
                      @gradientButtonClicked="submit"
                      :title="determineButtonText()"
                      :small="isMobile"
                      :callout="'right'"
                      class="mt-10"
                    />
                  </v-row>
                </v-card-text>
              </v-card>
            </v-row>
          </v-col>
        </v-col>
        <transition name="slide-right">
          <v-col
            xl="6"
            lg="6"
            md="12"
            sm="12"
            xs="12"
            v-if="submitted"
            @transitionend="scrollIntoView"
            class="calculator-column"
          >
            <v-col
              cols="12"
              class="estate-administration-costs-container"
              ref="estateAdministration"
              :style="{
                borderColor: whitelabel.colors.primary,
                backgroundColor: whitelabel.colors.primaryAlpha,
              }"
            >
              <h3 class="header-title padding-bottom-42">
                Your Estate Administration Costs
              </h3>
              <v-card class="card-container calculator-border-radius">
                <v-row
                  class="pl-5 pr-5 calculator-card-header align-center justify-space-between"
                  :style="{ backgroundColor: whitelabel.colors.primary }"
                >
                  <v-col xl="5" lg="7" md="12" sm="12" class="total-cost-row">
                    <h4 class="white--text total-cost-title">
                      {{ calculatorHeaderWording }}
                    </h4>
                  </v-col>
                  <v-col xl="5" lg="5" md="12" sm="12" class="total-cost-row">
                    <h4 class="text-right total-cost-amount">
                      R {{ totalCosts }}
                    </h4>
                  </v-col>
                </v-row>
                <v-card-text class="calculator-card">
                  <v-row
                    class="align-center calculator-cost-row justify-content-between"
                  >
                    <v-col lg="7" md="12" sm="12" class="d-flex align-center">
                      <h4 class="d-flex align-center calculator-label">
                        Executor Fees
                        <span class="d-flex align-center mobile-tooltip">
                          <img
                            :src="
                              require(`@/assets/old_mutual/icons/tooltip-icon.svg`)
                            "
                            alt="Estimated Insurance Required"
                            class="tooltip-icon"
                            v-tooltip="{ name: 'executor-fees' }"
                          />
                        </span>
                      </h4>
                    </v-col>
                    <v-col
                      lg="5"
                      md="12"
                      sm="12"
                      class="d-flex align-center value-column"
                    >
                      <TextField
                        :readonly="true"
                        :value="currencyExecutorFeesValue"
                        prefix="R"
                        :calculator-margins="true"
                        :default-margin="false"
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    class="align-center calculator-cost-row justify-content-between"
                  >
                    <v-col lg="7" md="12" sm="12" class="d-flex align-center">
                      <h4 class="d-flex align-center calculator-label">
                        Conveyancing Fees
                        <span class="d-flex align-center mobile-tooltip">
                          <img
                            :src="
                              require(`@/assets/old_mutual/icons/tooltip-icon.svg`)
                            "
                            alt="Estimated Insurance Required"
                            class="tooltip-icon"
                            v-tooltip="{ name: 'conveyancing-fees' }"
                          />
                        </span>
                      </h4>
                    </v-col>
                    <v-col
                      lg="5"
                      md="12"
                      sm="12"
                      class="d-flex align-center value-column"
                    >
                      <TextField
                        :readonly="true"
                        :value="currencyConveyancingFeesValue"
                        prefix="R"
                        :default-margin="false"
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    class="align-center calculator-cost-row justify-content-between"
                  >
                    <v-col lg="7" md="12" sm="12" class="d-flex align-center">
                      <h4 class="d-flex align-center calculator-label">
                        Master's Fees
                        <span class="d-flex align-center mobile-tooltip">
                          <img
                            :src="
                              require(`@/assets/old_mutual/icons/tooltip-icon.svg`)
                            "
                            alt="Estimated Insurance Required"
                            class="tooltip-icon"
                            v-tooltip="{ name: 'masters-fees' }"
                          />
                        </span>
                      </h4>
                    </v-col>
                    <v-col
                      lg="5"
                      md="12"
                      sm="12"
                      class="d-flex align-center value-column"
                    >
                      <TextField
                        :readonly="true"
                        :value="currencyMastersFeesValue"
                        prefix="R"
                        :default-margin="false"
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    class="align-center calculator-cost-row justify-content-between"
                  >
                    <v-col lg="7" md="12" sm="12" class="d-flex">
                      <h4 class="d-flex align-center calculator-label">
                        Standard <br />Administration Fees
                        <span class="d-flex align-center mobile-tooltip">
                          <img
                            :src="
                              require(`@/assets/old_mutual/icons/tooltip-icon.svg`)
                            "
                            alt="Estimated Insurance Required"
                            class="tooltip-icon"
                            v-tooltip="{
                              name: 'standard-administration-costs',
                            }"
                          />
                        </span>
                      </h4>
                    </v-col>
                    <v-col
                      lg="5"
                      md="12"
                      sm="12"
                      class="d-flex align-center value-column"
                    >
                      <TextField
                        :readonly="true"
                        :value="currencyStandardAdministrationFeesValue"
                        prefix="R"
                        :default-margin="false"
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    class="align-center calculator-cost-row justify-content-between"
                  >
                    <v-col lg="7" md="12" sm="12" class="d-flex align-center">
                      <h4 class="d-flex align-center calculator-label">
                        Estate Duty
                        <span class="d-flex align-center mobile-tooltip">
                          <img
                            :src="
                              require(`@/assets/old_mutual/icons/tooltip-icon.svg`)
                            "
                            alt="Estimated Insurance Required"
                            class="tooltip-icon"
                            v-tooltip="{ name: 'estate-duty' }"
                          />
                        </span>
                      </h4>
                    </v-col>
                    <v-col
                      lg="5"
                      md="12"
                      sm="12"
                      class="d-flex align-center value-column"
                    >
                      <TextField
                        :readonly="true"
                        :value="currencyEstateDutyFeesValue"
                        prefix="R"
                        :default-margin="false"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="justify-center center-row calculator-info">
                    <p class="info-text">
                      Once you have finalised your will, you will have
                      <strong :style="{ color: whitelabel.colors.primary }"
                        >access to our affordable products</strong
                      >
                      to cover your estate administration costs. 
                    </p>
                  </v-row>
                  <v-row
                    class="align-center justify-center draft-button center-row"
                  >
                    <GradientButton
                      @gradientButtonClicked="signup"
                      :title="isMobile ? 'Draft My Will' : 'Draft My Will Now'"
                      :small="isMobile"
                      :callout="'right'"
                      class="mt-10"
                    />
                  </v-row>
                </v-card-text>
              </v-card>
              <v-row class="mt-10 pb-2">
                <v-col cols="12" class="please-note">
                  <h4>*PLEASE NOTE</h4>
                  <p class="ma-0">
                    The values are illustrative of the costs based on the
                    information you have provided and they may change over time.
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-col>
        </transition>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import {
  formatCurrency,
  parseCurrency,
  isNumberCheck,
} from "@/constants/js/currency-input";
import { tooltipContent } from "@/constants/js/tooltip-content";
export default {
  name: "EstateCostCalculator",
  components: {},
  data() {
    return {
      inputs: {
        propertiesValue: 0,
        lifePoliciesValue: 0,
        vehiclesValue: 0,
        otherAssetsValue: 0,
        totalLiabilitiesValue: 0,
      },
      focusedField: null,
      calculatedFees: {
        executorFees: 0,
        conveyancingFees: 0,
        mastersFees: 0,
        standardAdministrationFees: 8000,
        estateDutyFees: 0,
      },
      grossValueOfEstate: 0,
      netValueOfEstate: 0,
      buttonLoading: false,
      submitted: false,
      vatRate: parseFloat(1 + this.$store.getters.vatRate),
      conveyancingFeesData: null,
      showRequestACallDialog: false,
      deedsOfficeFee: null,
      transferFee: null,
      disbursements: 4000,
    };
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
    calculatorHeaderWording() {
      return this.isMobile
        ? "Total liquidity needed in your estate*"
        : "Total Cost*";
    },
    mobileClass() {
      return {
        "mobile-sizing": this.isMobile,
      };
    },
    imageClass() {
      return {
        "md-image-resize": window.innerWidth <= 1260,
      };
    },
    currencyPropertiesValue: {
      get: function () {
        return formatCurrency(this.inputs.propertiesValue);
      },
      set: function (newValue) {
        this.inputs.propertiesValue = parseCurrency(newValue);
      },
    },
    currencyLifePoliciesValue: {
      get: function () {
        return formatCurrency(this.inputs.lifePoliciesValue);
      },
      set: function (newValue) {
        this.inputs.lifePoliciesValue = parseCurrency(newValue);
      },
    },
    currencyVehiclesValue: {
      get: function () {
        return formatCurrency(this.inputs.vehiclesValue);
      },
      set: function (newValue) {
        this.inputs.vehiclesValue = parseCurrency(newValue);
      },
    },
    currencyOtherAssetsValue: {
      get: function () {
        return formatCurrency(this.inputs.otherAssetsValue);
      },
      set: function (newValue) {
        this.inputs.otherAssetsValue = parseCurrency(newValue);
      },
    },
    currencyTotalLiabilitiesValue: {
      get: function () {
        return formatCurrency(this.inputs.totalLiabilitiesValue);
      },
      set: function (newValue) {
        this.inputs.totalLiabilitiesValue = parseCurrency(newValue);
      },
    },
    currencyExecutorFeesValue: {
      get: function () {
        return formatCurrency(this.calculatedFees.executorFees);
      },
      set: function (newValue) {
        this.calculatedFees.executorFees = parseCurrency(newValue);
      },
    },
    currencyMastersFeesValue: {
      get: function () {
        return formatCurrency(this.calculatedFees.mastersFees);
      },
      set: function (newValue) {
        this.calculatedFees.mastersFees = parseCurrency(newValue);
      },
    },
    currencyConveyancingFeesValue: {
      get: function () {
        return formatCurrency(this.calculatedFees.conveyancingFees);
      },
      set: function (newValue) {
        this.calculatedFees.conveyancingFees = parseCurrency(newValue);
      },
    },
    currencyStandardAdministrationFeesValue: {
      get: function () {
        return formatCurrency(this.calculatedFees.standardAdministrationFees);
      },
      set: function (newValue) {
        this.calculatedFees.standardAdministrationFees =
          parseCurrency(newValue);
      },
    },
    currencyEstateDutyFeesValue: {
      get: function () {
        return formatCurrency(this.calculatedFees.estateDutyFees);
      },
      set: function (newValue) {
        this.calculatedFees.estateDutyFees = parseCurrency(newValue);
      },
    },
    totalCosts: {
      get: function () {
        return formatCurrency(
          Object.values(this.calculatedFees).reduce(
            (acc, val) => +acc + Math.floor(+val),
            0
          )
        );
      },
    },
  },
  created() {
    this.conveyancingFeesData =
      this.whitelabel.estateAdministrationCostCalculator.conveyancingFeesData;
    this.mastersFeesData =
      this.whitelabel.estateAdministrationCostCalculator.mastersFeesData;
  },
  methods: {
    getHint(key) {
      if (key === this.focusedField) {
        return tooltipContent.find((item) => item.name === key)?.body;
      }
    },
    getTitle(key) {
      return tooltipContent.find((item) => item.name === key)?.title;
    },
    submit() {
      this.submitted = true;
      this.performCalculations();
      if (this.isMobile) {
        setTimeout(() => {
          this.scrollIntoView();
        }, 888);
      }
    },
    isNumber(event) {
      isNumberCheck(event);
    },
    handleFocus(vModel) {
      this.focusedField = vModel;
    },
    handleBlur(vModel) {
      if (this.inputs[vModel] === "") {
        this.inputs[vModel] = 0;
      }
    },
    scrollIntoView() {
      requestAnimationFrame(() => {
        this.$refs.estateAdministration.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    },
    performCalculations() {
      this.zeroValues();
      this.calculateGrossValueOfEstate();
      this.calculateExecutorFees();
      this.calculateTransferFee();
      this.calculateMastersFees();
      this.calculateDeedsOfficeFee();
      this.calculateTotalConveyancingFees();
      this.calculateNetValueOfEstate();
      this.calculateEstateDutyFees();
    },
    zeroValues() {
      this.calculatedFees.executorFees = 0;
      this.calculatedFees.conveyancingFees = 0;
      this.calculatedFees.mastersFees = 0;
      this.calculatedFees.estateDutyFees = 0;
      this.deedsOfficeTransferFee = 0;
      this.netValueOfEstate = 0;
      this.grossValueOfEstate = 0;
      this.transferFee = 0;
    },
    calculateGrossValueOfEstate() {
      const keysToExclude = ["totalLiabilitiesValue", "lifePoliciesValue"];
      const filteredValues = Object.keys(this.inputs).reduce((acc, key) => {
        if (!keysToExclude.includes(key)) {
          acc[key] = this.inputs[key];
        }
        return acc;
      }, {});

      this.grossValueOfEstate = Object.values(filteredValues).reduce(
        (acc, val) => +acc + +val,
        0
      );
    },
    calculateExecutorFees() {
      this.calculatedFees.executorFees = parseInt(
        this.grossValueOfEstate * 0.035 * this.vatRate
      );
    },
    calculateTransferFee() {
      const marketValue = this.inputs.propertiesValue;
      let excess;
      if (this.inputs.propertiesValue <= 0) {
        this.transferFee = 0;
        return;
      }
      switch (true) {
        case marketValue >= 0 && marketValue <= 100000:
          return (this.transferFee = 6435);
        case marketValue >= 100001 && marketValue <= 500000:
          excess = parseInt(marketValue - 100000);
          return (this.transferFee = 6435 + Math.floor(excess / 50000) * 1025);
        case marketValue >= 500001 && marketValue <= 1000000:
          excess = parseInt(marketValue - 500000);
          return (this.transferFee =
            14635 + Math.floor(excess / 100000) * 1985);
        case marketValue >= 1000001 && marketValue <= 5000000:
          excess = parseInt(marketValue - 1000000);
          return (this.transferFee =
            24560 + Math.floor(excess / 200000) * 1985);
        default:
          excess = parseInt(marketValue - 5000000);
          return (this.transferFee =
            64260 + Math.floor(excess / 1000000) * 5000);
      }
    },
    calculateDeedsOfficeFee() {
      const marketValue = this.inputs.propertiesValue;
      let fee;

      if (marketValue >= 0 && marketValue <= 100000) {
        fee = 47.0;
      } else if (marketValue <= 200000) {
        fee = 107.0;
      } else if (marketValue <= 300000) {
        fee = 682.0;
      } else if (marketValue <= 600000) {
        fee = 850.0;
      } else if (marketValue <= 800000) {
        fee = 1196.0;
      } else if (marketValue <= 1000000) {
        fee = 1374.0;
      } else if (marketValue <= 2000000) {
        fee = 1544.0;
      } else if (marketValue <= 4000000) {
        fee = 2140.0;
      } else if (marketValue <= 6000000) {
        fee = 2596.0;
      } else if (marketValue <= 8000000) {
        fee = 3092.0;
      } else if (marketValue <= 10000000) {
        fee = 3615.0;
      } else if (marketValue <= 15000000) {
        fee = 4303.0;
      } else if (marketValue <= 20000000) {
        fee = 5169.0;
      } else {
        fee = 6885.0;
      }

      return (this.deedsOfficeFee = fee);
    },

    calculateTotalConveyancingFees() {
      if (this.transferFee > 0) {
        const vatOnTransfer = this.transferFee * 0.15;
        this.calculatedFees.conveyancingFees =
          vatOnTransfer +
          this.transferFee +
          this.deedsOfficeFee +
          this.disbursements;
      }
    },
    calculateMastersFees() {
      if (this.grossValueOfEstate < 250000) {
        return;
      } else if (
        this.grossValueOfEstate >= 250000 &&
        this.grossValueOfEstate <= 399999
      ) {
        this.calculatedFees.mastersFees = 600;
        return;
      } else if (this.grossValueOfEstate >= 3500000) {
        this.calculatedFees.mastersFees = 7000;
        return;
      }

      if (this.grossValueOfEstate >= 400000) {
        const increments = parseInt(this.grossValueOfEstate / 100000);
        this.calculatedFees.mastersFees = 200 * increments;
      }
    },
    calculateEstateDutyFees() {
      const netValueOfEstateWithLifePolicies =
        this.netValueOfEstate + this.inputs.lifePoliciesValue;
      if (netValueOfEstateWithLifePolicies > 3500000) {
        const calculatedEstateDutyFees =
          (netValueOfEstateWithLifePolicies - 3500000) * 0.2;
        this.calculatedFees.estateDutyFees =
          calculatedEstateDutyFees > 0 ? calculatedEstateDutyFees : 0;
      }
    },
    calculateNetValueOfEstate() {
      const { estateDutyFees, executorFees, ...filteredValues } =
        this.calculatedFees;
      this.netValueOfEstate =
        this.grossValueOfEstate -
        (this.inputs.totalLiabilitiesValue +
          Object.values(filteredValues).reduce((acc, val) => +acc + +val, 0));
    },
    determineButtonText() {
      if (!this.isMobile) {
        return !this.submitted ? "Calculate My Costs" : "Re-calculate My Costs";
      } else {
        return !this.submitted ? "Calculate" : "Re-calculate";
      }
    },
    requestACall() {
      this.showRequestACallDialog = true;
    },
    signup() {
      this.$router.push("register");
    },
    showSuccessMessage(success) {
      this.$emit("success", success);
    },
  },
};
</script>
<style lang="scss" scoped>
.master-container {
  background-color: transparent;
}
.calculator-container {
  margin: 22px 0 0 0 !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  .make-full-width {
    height: 100% !important;
  }
}

.component-container {
  padding-bottom: 50px;
}

h2 {
  font-size: 40px;
}

h3 {
  font-size: 28px;
  font-weight: 500;
}

h4 {
  color: #000;
  font-size: 18px;
  font-weight: 600;
  gap: 11px;

  &.values {
    font-size: 18px;
    font-weight: 400 !important;
  }
}

.header-title {
  padding: 0 0 30px 0;
  &.padding-bottom-42 {
    padding-bottom: 45px;
  }
}

.value-column {
  justify-content: flex-end;
}

.estate-calculator-container {
  gap: 60px;
  margin-bottom: 111px;
}

.heading-paragraph {
  padding: 11px 60px;
  font-size: 18px;
  max-width: 928px;
}

.summary-of-assets-container {
  transition: all 2s linear;
  padding: 30px 28px 159px 28px;
  border: 1.5px solid #282828;
  min-height: 600px;
  position: relative;

  p {
    padding-right: 28px;
  }

  p {
    margin-bottom: 40px;
  }
}
.calculator-input {
  font-size: 18px;
}

.estate-administration-costs-container {
  padding: 30px 28px;
  border: 1.5px solid;
}

.estate-administration-costs-container {
  .calculator-card {
    padding: 15px 24px 40px 24px;
  }
}

.card-container {
  border-radius: 0 !important;
  &.calculator-border-radius {
    border-top-left-radius: 11px !important;
    border-top-right-radius: 11px !important;
  }
}
.calculator-card {
  width: 100%;
  padding: 40px 24px;
}

.calculator-card-header {
  height: 110px;
  margin: 0 !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  border-radius: 8px;
}

.total-cost-title {
  font-size: 24px;
  font-weight: bold;
}

.total-cost-amount {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

hr {
  border-color: rgba(135, 135, 135, 0.1);
  height: 1px;
}

.circle-background {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background-color: rgba(243, 242, 242, 1);
  box-sizing: border-box;
}

.info-text {
  font-size: 20px;
  font-weight: 400;
  margin: 30px 0 0 0;
  padding: 0 20px;
}

.summary-info {
  font-size: 16px;
  font-weight: 400;
}

.please-note {
  padding: 0 25px 0 33px;
  h4 {
    font-weight: 400px;
    font-size: 16px !important;
    line-height: 22.4px !important;
  }
  p {
    font-size: 14px !important;
    font-weight: 300 !important;
    line-height: 19.6px !important;
    color: black !important;
  }
}

.mobile-sizing {
  flex: 1 0 100%;
}

.md-image-resize {
  width: 100%;
}

.calculator-row {
  h4 {
    * {
      display: flex;
      align-items: center;
    }
  }
  padding: 0 12px;
}
.calculator-col-padding {
  padding: 0;
}

.mobile-tooltip {
  z-index: 1;
  div {
    display: flex;
    align-items: center;
  }
}

.button-row {
  margin-top: 55px;
  margin-bottom: -6px;
}

.draft-button {
  margin-top: 16px;
  margin-bottom: -7px;
}

.info-column {
  padding-top: 38px;
  padding-bottom: 9px;
}

.calculator-cost-row {
  margin-bottom: -4px;
  margin-top: 0;
}

@media (max-width: 1263px) {
  .component-container {
    padding: 6px 24px 50px 24px;
    .heading-column-container {
      align-items: center;

      .heading-row {
        align-items: center;
        flex-direction: column;
      }
    }

    h2 {
      text-align: center;
      margin-bottom: 60px;
      margin: 25px 60px 30px 60px;
      line-height: normal;
      font-size: 32px;
    }

    .heading-column {
      display: flex;
      justify-content: center;
      margin: 0;
      text-align: center;
    }

    .heading-paragraph {
      padding: 0 26px 0 24px;
      font-size: 16px;
    }

    .estate-calculator-container {
      padding: 0 16px;
      flex-direction: column;
      margin-top: 10px !important;
    }

    .total-cost-title {
      margin-bottom: 20px;
    }

    .calculator-card {
      h4 {
        font-size: 16px;
        width: 100%;

        span {
          width: auto;
        }
      }

      span:not(.mobile-tooltip) {
        width: 100%;
      }

      .row:not(.center-row) {
        flex-direction: column;
        align-items: unset !important;
      }

      .value-column {
        justify-content: flex-start;

        .values {
          text-align: left !important;
          font-size: 18px;
        }
      }

      .calculator-info {
        margin-top: 0;
      }
    }

    .estate-administration-costs-container {
      padding: 40px 8px;

      h4 {
        font-size: 20px;
        font-weight: 700;
        line-height: 30px;
      }

      .total-cost-amount {
        padding: 11px 0;
        font-size: 24px;
        font-weight: 600;
      }

      .calculator-label {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
      }

      .circle-background {
        box-shadow: unset !important;
      }
    }
    .info-row {
      margin-bottom: 1.5em;
    }
    .calculator-card {
      padding: 40px 12px;
    }
  }

  .please-note {
    padding: 0 44px;
    h4 {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 140%;
    }
    p {
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 140%;
    }
  }
  .calculator-row {
    // margin-bottom: -2.4em !important;
    .calculator-label-column {
      padding: 0 0 0 16px;
    }
    .calculator-value-column {
      padding: 0 0 30px 16px;
    }
  }

  .calculator-cost-row {
    :first-child:not(.tooltip-inner) {
      padding-bottom: 0;
    }
  }
  .info-column {
    margin-top: -20px;
  }
  .button-row {
    margin-top: 16px !important;
    margin-bottom: -6px !important;
  }
  .calculator-card-header {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    padding: 24px 16px;
    .total-cost-row {
      padding: 0;
      flex-basis: 100% !important;
    }
  }
  .calculator-card-header {
    height: auto;
  }
}

@media screen and (max-width: 430px) {
  .master-container {
    padding: 0;
  }

  .card-container {
    padding: 0 0 17px 0;
  }

  .header-title {
    line-height: 32px !important;
  }

  .summary-of-assets-container {
    padding: 30px 8px !important;
  }
  .component-container {
    padding: 46px 24px;

    .header-title,
    .summary-info {
      padding-left: 23px;
      padding-right: 23px;
    }

    .card-container {
      padding: 0 0 17px 0;

      .calculator-row {
        margin: 0;
      }
      .info-row {
        margin-top: 0;
        padding: 0 16px;
      }
    }

    .estate-administration-costs-container {
      .header-title {
        padding-left: 10px;
        padding-right: 0;
      }
      .card-container {
        .calculator-card-header {
          height: auto;

          .total-cost-row {
            padding: 0;
          }
        }
      }
      .circle-background {
        margin-top: 10px;
        margin-bottom: 8px;
      }
      .mobile-tooltip {
        z-index: unset;
      }
    }

    h3 {
      font-size: 28px;
    }
    .heading-row {
      h3 {
        margin-top: 11px;
      }
    }
    .heading-paragraph {
      margin: 28px 0;
    }
    .mobile-sizing {
      padding-top: 0;
      margin-top: -10px;
    }
  }
}
//Transitions

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
  transition-timing-function: ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.333s;
  transition-timing-function: ease-in;
}

.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(100%);
  transition-delay: 3.33s;
}

.slide-right-enter-to,
.slide-right-leave {
  transform: translateX(0);
}
.total-cost-row {
  flex-basis: 100% !important;
}

@media only screen and (min-device-width: 0px) and (max-device-width: 812px) {
  .summary-of-assets-container {
    padding: 30px 8px;
    .header-title {
      padding-left: 20px;
      padding-right: 20px;
    }
    .summary-info {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .summary-of-assets-container {
    padding: 30px 28px;
  }
  .calculator-card {
    padding: 40px 24px;
  }
  .info-row {
    margin-bottom: 1.5em;
  }
  .calculator-card-header {
    height: auto;
  }
  .mobile-tooltip {
    z-index: unset;
  }
}

@media only screen and (min-device-width: 1904px) and (max-device-width: 5000px) {
  .calculator-container {
    min-width: 1552px !important;
  }
  .make-full-width {
    min-width: 752px !important;
  }
  .summary-of-assets-container {
    min-width: 752px !important;
  }
}

.om-design {
  .calculator-row {
    padding: 0;
    margin: 0;
    .calculator-value-column {
      padding: 0 !important;
    }
  }
  .calculator-cost-row {
    padding: 0 12px;
    margin-bottom: 24px !important;
    * {
      padding: 0 !important;
    }
    .value-column {
      padding: 0 !important;
      margin: 0 !important;
    }
  }
  .info-row {
    padding: 0 !important;
    margin: 0 !important;
    .info-column {
      padding: 0 !important;
      margin-bottom: 24px;
    }
  }
}
</style>
